export enum Role {
  Developer = 'Developer',
  Administrator = 'Administrator',
  Subscriber = 'Subscriber'
}
